<template lang="html">
  <div id="amenities-popup">
    <!-- Close button -->
    <button class="close-btn" @click="close()">
      <i class="material-icons">close</i>
    </button>

    <!-- Rendering -->
    <div class="rendering" :style="{'background-image': 'url(' + rendering + ')'}"></div>

    <!-- Caption -->
    <div class="caption">
      <span v-text="point.name"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'amenities-popup',
  props: {
    point: {
      type: Object,
      default: () => undefined
    }
  },
  computed: {
    rendering() {
      return `/static/img/${this.point.rendering}.jpg`;
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss">
#amenities-popup {
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  background-color: black;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;

  button.close-btn {
    position: absolute;
    top: 0;
    left: 0;
    padding: 1rem;
    color: white;
    background-color: transparent;
    border: none;
    outline: none;
    padding: 1.25rem;
    cursor: pointer;
    &:active { transform: scale(0.9); }

    i.material-icons {
      font-size: 2.25rem;
    }
  }

  .rendering {
    width: 100%;
    height: 100vh;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
  }

  .caption {
    position: absolute;
    bottom: 5vh;
    left: 0;
    width: 100%;
    transform: translateY(50%);

    span {
      font-weight: bold;
      font-size: 1.25rem;
      padding: 0.75rem 1.5rem;
      letter-spacing: 1px;
      display: inline-block;
      color: white;
      background-color: rgba(0, 0, 0, 0.75);

      @media (max-width: 1024px) {
        font-size: 1rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Popup.vue